<template>
  <div class="athena-404">
    <div class="athena-404-main container">
      <h1>{{$t('athena.error.not_found_title')}}</h1>
      <p>{{$t('athena.error.not_found_content1')}}</p>
      <a href="/collections/all">{{$t('athena.error.not_found_content2')}} ></a>
      <v-search-input></v-search-input>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style scoped lang='scss'>
.athena-404 {
  background: #f7f7f9;
  &-main {
    padding-top: 140px;
    padding-bottom: 190px;
    font-family: Roboto;
    text-align: center;
    h1 {
      font-size: 26px;
      font-weight: bold;
      color: #222940;
      text-transform: uppercase;
    }
    p {
      margin-top: 50px;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
    }
    a {
      display: block;
      margin-top: 40px;
      font-size: 16px;
      font-weight: 500;
      color: #222940;
      text-transform: uppercase;
    }
    ::v-deep.search-input {
      margin-top: 40px;
      max-width: 500px;
      .secondary_title {
      background: #f7f7f9;
    }
    }
  }
  @media screen and(max-width: 768px) {
    &-main {
      h1 {
        font-size: 15px;
      }
      p{
          margin-top: 15px;
          line-height: 18px;
      }
      a{
          margin-top: 30px;
      }
      p,
      a {
        font-size: 13px;
      }
      ::v-deep.search-input {
        max-width: 345px;
        margin-top: 30px;
        input {
          height: 40px;
        }
      }
    }
  }
}
</style>